/* globals Elm */
import { handleFileUpload } from '../../../../../EngageCore.Common/JavaScript/fileUpload.mjs';
import { initPorts } from '../../../../../EngageCore.Common/Javascript/pictureUpload.mjs';

/**
 * @param {HTMLElement} element The element
 * @param {object} options The options
 * @param {object} dnnServiceFramework The DNN service framework
 */
export function init({ node: element, flags: options }, dnnServiceFramework) {
	const FILE_UPLOADING = 'FileUploading';
	const FILE_ERROR = 'FileError';
	const FILE_UPLOADED = 'FileUploaded';
	const CHECK_PARTICIPANT_MATCH = 'CheckParticipantMatch';
	const FILE_SELECTED = 'FileSelected';
	const PARTICIPANT_CHANGED = 'ParticipantChanged';
	const KEY = 'engagecore-Key';

	if (dnnServiceFramework) {
		options.baseUrl = dnnServiceFramework.getServiceRoot('EngageCore');
		options.headers = {
			ModuleId: dnnServiceFramework.getModuleId().toString(),
			TabId: dnnServiceFramework.getTabId(),
			RequestVerificationToken: dnnServiceFramework.getAntiForgeryValue(),
		};
	}

	options.now = Date.now();

	const elmApp = Elm.Engage.Membership.Registration.Main.init({
		node: element,
		flags: options,
	});

	/**
	 * @param {string} key The key
	 * @param {object} value The value
	 */
	function sendSub(key, value) {
		elmApp.ports.sub.send({
			[KEY]: key,
			value,
		});
	}

	/**
	 * @param {object} formData The form data
	 * @param {number} progressPercentage The progress percentage
	 */
	function fileUploadingSub(formData, progressPercentage) {
		sendSub(
			FILE_UPLOADING,
			Object.assign(formData, {
				progressPercentage,
			}),
		);
	}

	/**
	 * @param {object} formData The form data
	 * @param {object} data The file data
	 * @param {string} textStatus The text status
	 */
	function fileUploadedSub(formData, data, textStatus) {
		sendSub(
			FILE_UPLOADED,
			Object.assign(formData, data, {
				textStatus,
			}),
		);
	}

	/**
	 * @param {object} formData The form Id
	 * @param {string} textStatus The text status
	 * @param {string} errorThrown The error thrown
	 */
	function fileUploadError(formData, textStatus, errorThrown) {
		sendSub(
			FILE_ERROR,
			Object.assign(formData, {
				textStatus,
				errorThrown,
			}),
		);
	}

	/**
	 * @param {object} json The json
	 */
	function handleFileSelected(json) {
		handleFileUpload(
			`${options.baseUrl}RegistrationFile`,
			dnnServiceFramework?.setModuleHeaders ??
				(() => {
					//
				}),
			json,
			(data, status) => fileUploadedSub(json, data, status),
			(status, response) => fileUploadError(json, status, response),
			(progressPercentage) => fileUploadingSub(json, progressPercentage),
		);
	}

	initPorts(elmApp);

	elmApp.ports.out.subscribe((json) => {
		switch (json[KEY]) {
			case FILE_SELECTED:
				handleFileSelected(json.value);
				break;
			case PARTICIPANT_CHANGED:
				sendSub(CHECK_PARTICIPANT_MATCH, null);
				break;
			default:
				break;
		}
	});
}
